import SignUpView from 'core/lite/views/SignUpView';
import SignUpStatus from 'core/lite/views/SignUpView/SignUpStatus/SignUpStatus';
import useSignUp from 'core/lite/views/SignUpView/useSignUp';
import { clientIdMicrosoft, TERMS } from 'edelvives/config/config';
import initLayoutConfig from 'edelvives/config/layout/LayoutConfig';
import LandingEdelvivesPlus from 'edelvives/modules/compositions/LandingEdelvivesPlus/LandingEdelvivesPlus';
import React from 'react';

function getMicrosoftClientId(origin) {
  return clientIdMicrosoft[origin];
}

function SignUpPage() {
  const { loading, viewProps, identify } = useSignUp({ addLicenseWithoutContent: true, getMicrosoftClientId });

  function onSuccessGoogle({ profileObj, tokenId }) {
    identify('google', { email: profileObj.email, name: profileObj.givenName, surname: profileObj.familyName, token: tokenId });
  }

  return (
    <div>
      <SignUpView
        {...viewProps}
        configProgramPicture={initLayoutConfig.programPicture}
        onSuccessGoogle={onSuccessGoogle}
        layoutRight={<LandingEdelvivesPlus />}
        terms={TERMS}
      />
      <SignUpStatus isLoading={loading} />
    </div>
  );
}

export default SignUpPage;
